import {
  DASHBOARD_BANNER,
  READ_ACTION,
  PROFILE,
  CREATE_ACTION,
} from "@/constants/resources";

export default [
  {
    title: "Configurações",
    icon: "none",
    children: [
      {
        title: "Perfis de acesso",
        route: "access-profiles-list",
        icon: "ListIcon",
        resource: PROFILE,
        action: CREATE_ACTION,
      },
      {
        title: "Banners",
        route: "dashboard-banners",
        icon: "ImageIcon",
        resource: DASHBOARD_BANNER,
        action: READ_ACTION,
      },
    ],
  },
];
